import {
  type ComponentProps,
  type LayoutData,
  Region,
} from "@enonic/react-components";

export const OneColumnLayout = ({
  component,
  meta,
  data,
}: ComponentProps<LayoutData>) => {
  const margin = typeof data?.margin === "string" ? data.margin : "";
  return (
    <div className={`container ${margin}`}>
      <Region
        data={component.regions.left.components}
        meta={meta}
        name="left"
      />
    </div>
  );
};
